import { render, staticRenderFns } from "./PaymentSocials.vue?vue&type=template&id=49dad268&"
import script from "./PaymentSocials.vue?vue&type=script&lang=js&"
export * from "./PaymentSocials.vue?vue&type=script&lang=js&"
import style0 from "./PaymentSocials.vue?vue&type=style&index=0&id=49dad268&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports